/**
 * @Description:WebsocketDemo
 * @author JiangJiang
 * @date 2021/9/9 16:01
 */

import { useCallback, useEffect, useState } from "react";
import { useWebsocket } from "@utils/hooks";
import Logs from "@utils/Logs";
import { useSelector } from "react-redux";
import { Button, Col, Divider, message, Row } from "antd";
import { webSocketStatus } from "@utils/filter";

const WebsocketDemo = () => {
  //未登录 无token
  const wsUrl = 'wss://mediation-front-dev0.xinztech.com/ic/court/api/v1/mediationCenter/lostConRepair/lcPendingMediationDivision/mobileCheckStatus?token=' + localStorage.getItem('token')
  const [socketData, setSocketData] = useState({})
  const { messageData, readyState, closeWebSocket, reconnect, sendMessage } = useWebsocket({ url: wsUrl })
  const [processNum, setProcessNum] = useState({ totalNum: undefined, successNum: undefined })
  Logs.debug('readyState', readyState)
  Logs.debug('messageData', messageData)
  const onHandleSendMessage = useCallback(() => {
      sendMessage(JSON.stringify({ isClose: webSocketStatus.START_MSG }))
  }, [])

  /**
   * 监听msgData
   */
  useEffect(() => {
    if (!!messageData) {
      const msgData = JSON.parse(messageData)
      const { status, des } = msgData
      if (status !== 2000) {
        message.error(des)
        return
      }
      const { totalNum, successNum } = msgData

      setProcessNum({
        totalNum,
        successNum
      })
    }
  }, [messageData])


  const onCanceleSendMessage = useCallback(() => {
    sendMessage(JSON.stringify({ isClose: webSocketStatus.CANCEL_MSG }))
    closeWebSocket()
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <h1>websocket测试</h1>
      {processNum.totalNum && <h1>{processNum.successNum}/{processNum.totalNum}</h1>}
      <Row>
        <Col>
          <Button onClick={onHandleSendMessage} type={'primary'} block>
            发送消息
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Col>
            <Button onClick={onCanceleSendMessage} block danger type={'primary'}>关闭连接</Button>
          </Col>
        </Col>
      </Row>
    </div>
  )
}
export default WebsocketDemo
